module.exports = __webpack_public_path__ + "static/media/lobbyM.d82d55e7.jpg";